import globals from'../globals.js';

function contact(){
    
    var buttons = document.querySelectorAll('.contact-trig');

    for (let a = 0; a < buttons.length; a++) {
        let elm = buttons[a];

        elm.addEventListener('click', function(e){
            e.preventDefault();
            let jumpTo = elm.dataset.url;
            const yOffset = -100; 
            const element = document.getElementById(jumpTo);
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({top: y, behavior: 'smooth'});
        });
        
    }
    // const trigger = document.querySelector('.hamburger');

    // trigger.addEventListener('click', function(){
    //     if(document.body.classList.contains('nav-open')){
    //         document.body.classList.remove('nav-open')
    //     }else{
    //         document.body.classList.add('nav-open')
    //     }
    // });



};


export default contact;